import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { RayForm, RayFormValidation, InputBasicText } from '../common';
import { InstallationAction, ProductAction } from '../../actions';
import { useTranslation } from 'react-i18next';
import { Translate as t } from '../../config/Translate';

const SubItemList = ({ name, type, info, handleChangeDataList, isSummary = false }) => {
	// const [ t, i18n ] = useTranslation();
	const [list, setList] = useState(info || []);
	const [item, setItem] = useState({ type: type, title: "", ip: "", port: "" });

	useEffect(() => {
		handleChangeDataList(name, list);
	}, [list]);

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		setItem({ ...item, [name]: value });
	}
	const Add = () => {
		setList([...list, item]);
		setItem({ type: type, title: "", ip: "", port: "" });
	}
	const Del = (idx) => {
		list.splice(idx, 1);
		setList([...list]);
	}
	return (
		<>
			<div className="">
				<div className="card">
					<ul className="listview simple-listview no-space">
						{list.map((x, idx) =>
							<li key={idx}>
								{x.title} / {x.ip} / {x.port}
								{!isSummary && <button className="btn btn-sm btn-danger" onClick={() => Del(idx)}>{t('common.button.delete')}</button>}
							</li>
						)}
					</ul>
					{!isSummary &&
						<div className="">
							<InputBasicText
								options={{ val: item.title, name: "title", label: t('product.field.aeTitle') }}
								isForm={!isSummary}
								inline={false}
								editable={!isSummary}
								onchange={handleChangeData} />

							<InputBasicText
								options={{ val: item.ip, name: "ip", label: t('product.field.ipAddress') }}
								isForm={!isSummary}
								editable={!isSummary}
								onchange={handleChangeData} />

							<InputBasicText
								options={{ val: item.port, name: "port", label: t('product.field.port') }}
								isForm={!isSummary}
								editable={!isSummary}
								onchange={handleChangeData} />
							{!isSummary && <button className="btn btn-block btn-primary" onClick={() => Add()}>{t('common.button.add')}</button>}
						</div>
					}
				</div>
			</div>
		</>
	);
}

const InstallationStep3 = ({ info, Update, UpdateProductInfo, isSummary = false, product, site, gostep }) => {
	// const [ t, i18n ] = useTranslation();
	const siteId = info.siteId;
	const [installation, setInstallation] = useState(info);
	const [pInfo, setPInfo] = useState({
		networkstaticip: "",
		verRayio: "",
		verRaycan: "",
		verSmartDent: "",
		verRayServer: "",
		verOndemand3D: ""
	});

	useEffect(() => {
		setPInfo({
			networkstaticip: product.extrainfo && product.extrainfo.networkstaticip || "",
			verRayio: product.extrainfo && product.extrainfo.verRayio || "",
			verRaycan: product.extrainfo && product.extrainfo.verRaycan || "",
			verSmartDent: product.extrainfo && product.extrainfo.verSmartDent || "",
			verRayServer: product.extrainfo && product.extrainfo.verRayServer || "",
			verOndemand3D: product.extrainfo && product.extrainfo.verOndemand3D || ""
		});
	}, [product.extrainfo])

	const [isSubmitting, setIsSubmitting] = useState(false);

	// 현재 입력(제품 정보·PACS 목록)과 목표 단계를 함께 저장. '다음'·'이전'·상단 이동이 같이 쓴다.
	// 설치일(installedDate)은 앞으로 나아갈 때(목표 > 이 단계 4)만 갱신한다 — 되돌아가기가 설치 완료로 기록되지 않게.
	const saveStep = async (targetStep) => {
		setIsSubmitting(true);
		try {
			// SEC-015: sitename 은 BE sanitizer 가 strip(비화이트리스트). siteId 변경 시 서버가 Site.findOne 으로 재동기화 — 기존 delete item.sitename 와 동일 동작.
			const productInfo = { extrainfo: pInfo, sitename: site?.sitename || '' };
			if (targetStep > 4) {
				productInfo.installedDate = new Date().getTime();
			}
			await UpdateProductInfo(product._id, productInfo);
			await Update(installation._id, {
				pacsList: installation.pacsList,
				installationStep: targetStep
			});
		} catch (error) {
			console.error('InstallationStep3 saveStep error:', error);
		} finally {
			setIsSubmitting(false);
		}
	};

	const Prev = () => {
		saveStep(3);
	};

	const validNext = (targetStep = 5) => saveStep(targetStep);

	// 상단 배지·◀▶ 이동: 이 단계는 검증이 없으므로 현재 입력과 함께 목표 단계로 저장한다.
	useEffect(() => {
		if (gostep && gostep.curStep == 4) {
			validNext(gostep.goStepNo);
		}
	}, [gostep]);

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		setPInfo({ ...pInfo, [name]: value });
	};

	const handleChangeDataList = (type, list) => {
		const pList = (installation.pacsList || []).filter(x => x.type != type);
		setInstallation({ ...installation, pacsList: pList.concat(list) });
	}

	const form_controls = [
		{
			title: t('product.label.diagnosisResult'), items: [
				{ type: "input", name: "networkstaticip", label: t('product.field.networkStaticIp'), val: pInfo.networkstaticip, isEditable: !isSummary },
				{ type: "input", name: "verRayio", label: t('product.field.rayIoVersion'), val: pInfo.verRayio, isEditable: !isSummary },
				{ type: "input", name: "verRaycan", label: t('product.field.rayScanVersion'), val: pInfo.verRaycan, isEditable: !isSummary },
				{ type: "input", name: "verSmartDent", label: t('product.label.smartDentVersion'), val: pInfo.verSmartDent, isEditable: !isSummary },
				{ type: "input", name: "verRayServer", label: t('product.field.rayServerVersion'), val: pInfo.verRayServer, isEditable: !isSummary },
				{ type: "input", name: "verOndemand3D", label: t('product.field.onDemand3dVersion'), val: pInfo.verOndemand3D, isEditable: !isSummary }
			]
		},
	];

	return (
		<>
			<RayForm controls={form_controls} isSummary={isSummary} isForm={!isSummary} handleChangeData={handleChangeData} />
			<div className={isSummary ? "pb-1" : "section"}>
				<div className={isSummary ? "section-title bdB2" : "section-title"}>{t('product.type.pacs')}</div>
				<div className={isSummary ? "" : "card mb-2 pb-1"}>
					<div className={isSummary ? "" : "card-body"}>
						<div className={isSummary ? "mt-1" : ""}>
							<h4>1) {t('product.type.mwl')}</h4>
						</div>
						<SubItemList
							isSummary={isSummary}
							info={(info.pacsList || []).filter(x => x.type == "mwl")}
							type="mwl" name="mwl"
							handleChangeDataList={(type, list) => handleChangeDataList(type, list)} />
						<div className={isSummary ? "mt-1" : "mt-2"}>
							<h4>2) {t('product.type.dicomPrinter')}</h4>
						</div>
						<SubItemList
							isSummary={isSummary}
							info={(info.pacsList || []).filter(x => x.type == "dicom")}
							type="dicom" name="dicom"
							handleChangeDataList={(type, list) => handleChangeDataList(type, list)} />
						<div className={isSummary ? "mt-1" : "mt-2"}>
							<h4>3) SCP</h4>
						</div>
						<SubItemList
							isSummary={isSummary}
							info={(info.pacsList || []).filter(x => x.type == "scp")}
							type="scp" name="scp"
							handleChangeDataList={(type, list) => handleChangeDataList(type, list)} />
					</div>
				</div>
			</div>
			{!isSummary && <div className="section mt-1 mb-2">
				<button className={isSubmitting ? "btn btn-primary btn-block btn-lg disabled" : "btn btn-primary btn-block btn-lg"} onClick={() => !isSubmitting && validNext()}>{isSubmitting ? t('common.status.processing') || 'Processing...' : t('common.button.next')}</button>
				<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.back')}</button>
			</div>}
		</>
	);
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(InstallationAction.UpdateInstallation(_id, data)),
	UpdateProductInfo: (siteId, data) => dispatch(ProductAction.UpdateProductInfo(siteId, data)),
});

const mapState = (state) => ({
	site: state.SiteReducer.site,
});

export default connect(mapState, mapDispatch)(InstallationStep3);